import { getLabels } from '@/components/art7/dataDefinitions/labels'
import { fromExponential, isNumber, valueConverter, doSum } from '@/components/common/services/utilsService'
import tooltipOrder from '@/components/art7/dataDefinitions/modalFieldsOrder'

const getCountryField = (currentSection) => {
  switch (currentSection) {
  case 'has_exports':
    return 'destination_party'
  case 'has_imports':
    return 'source_party'
  default:
  }
}

const createTooltip = (fields, section, $gettext, textOnly) => {
  let tooltip_title = ''
  if (Object.keys(fields).length) {
    tooltipOrder.forEach(field => {
      if (Object.keys(fields).includes(field)) { tooltip_title += `${getLabels($gettext)[section][field]}: ${textOnly ? fields[field] : fromExponential(fields[field])}\n` }
    })
  }
  tooltip_title += `\n ${$gettext('Click to edit')}`
  return tooltip_title
}

const allEmpty = (fieldArr) => fieldArr.every((field) => field.selected === null)
const someEmpty = (fieldArr) => fieldArr.some((field) => field.selected === null) // - not used? - MM
const isLessThanSum = (field, fieldArr) => (
  field.selected !== null
  && !allEmpty(fieldArr)
  && valueConverter(field.selected) < doSum(
    fieldArr.map((obj) => obj.selected)
  )
)
const isDifferentThanSum = (field, fieldArr) => (
  field.selected !== null
  && !allEmpty(fieldArr)
  && valueConverter(field.selected) !== doSum(
    fieldArr.map((obj) => obj.selected)
  )
)

const quantityCalculator = (fields, parent, section, $gettext) => {
  const forTooltip = {}
  fields
    .filter((quantity) => parent[quantity].selected !== null)
    .forEach((quantity) => {
      forTooltip[quantity] = parent[quantity].selected
    })
  const sumQty = doSum(
    fields.map((field) => parent[field].selected)
  )

  return {
    type: 'nonInput',
    selected: sumQty !== null ? fromExponential(sumQty) : '',
    tooltip: createTooltip(forTooltip, section, $gettext)
  }
}

const decisionGenerator = (fields, parent, section, $gettext) => {
  const decisions = []
  const forTooltip = {}
  const decision_fields = fields.filter(item => parent[item].selected)
  tooltipOrder.forEach(item => {
    if (decision_fields.includes(item)) {
      decisions.push(parent[item].selected)
      forTooltip[item] = parent[item].selected
    }
  })

  return {
    type: 'nonInput',
    tooltip: createTooltip(forTooltip, section, $gettext, true),
    selected: decisions.join(', ')
  }
}

export default {
  nonSubstanceRows({
    $gettext, currentSectionName, prefillData, ordering_id
  }) {
    let row
    switch (currentSectionName) {
    case 'has_emissions':
      row = {
        checkForDelete: {
          selected: false,
          type: 'checkbox'
        },
        id: {
          selected: null
        },
        ordering_id: {
          selected: ordering_id || 0
        },
        facility_name: {
          type: 'text',
          selected: ''
        },
        quantity_generated: {
          type: 'number',
          selected: null
        },
        quantity_stored_beginning_year: {
          type: 'number',
          selected: null
        },
        quantity_captured_all_uses: {
          type: 'number',
          selected: null
        },
        quantity_captured_all_uses_excluding_feedstock: {
          type: 'number',
          selected: null
        },
        quantity_captured_feedstock: {
          type: 'number',
          selected: null
        },
        quantity_captured_for_destruction: {
          type: 'number',
          selected: null
        },
        quantity_feedstock: {
          type: 'number',
          selected: null
        },
        quantity_destroyed: {
          type: 'number',
          selected: null
        },
        quantity_emitted: {
          type: 'number',
          selected: null
        },
        quantity_stored_end_year: {
          type: 'number',
          selected: null
        },
        remarks_party: {
          type: 'textarea',
          selected: ''
        },
        remarks_os: {
          type: 'textarea',
          selected: ''
        },
        get validation() {
          const errors = []
          if (!this.facility_name.selected) {
            errors.push($gettext(
              'Please fill-in column Facility name or identifier (1)'
            ))
          }

          // Col 2 >= Col 4a + Col 4b + Col 4c + Col 5 + Col 6 + Col 7
          if (isLessThanSum(
            this.quantity_generated,
            [
              this.quantity_captured_all_uses_excluding_feedstock,
              this.quantity_captured_feedstock,
              this.quantity_captured_for_destruction,
              this.quantity_feedstock,
              this.quantity_destroyed,
              this.quantity_emitted
            ]
          )) {
            errors.push($gettext(
              'Total amount generated (2) must be greater than or equal to the sum of its components: Amount generated and captured for uses excluding feedstock(4a), amount used for feedstock in your country(4b), amount destroyed (4c), amount used for feedstock without prior capture (5), amount destroyed in the facility without prior capture (6) and amount of generated emissions (7)'
            ))
          }

          // Col 2 >= Col 4a + Col 4b + Col 4c + Col 5 + Col 6 + Col 7
          /* if (this.quantity_generated.selected != null) {
            // refs #8949, depending on whether 3a has been reported or not
            // When Col 3a has NOT been reported, use 3b+3c instead of 3a
           // const _captured_fields = this.quantity_captured_all_uses.selected != null ? [
            this.quantity_captured_all_uses
            ] : [
              this.quantity_captured_feedstock,
              this.quantity_captured_for_destruction
            ]
            const _fields = [
              ..._captured_fields,
              this.quantity_feedstock,
              this.quantity_destroyed,
              this.quantity_emitted
            ]

            // when some fields are empty, sum must be GREATER OR EQUAL
            if (
              someEmpty(_fields)
              && isLessThanSum(this.quantity_generated, _fields)
            ) {
              errors.push($gettext(
                'Total amount generated (2) must be greater than or equal to the sum of its components: Amount generated and captured for all uses (3a), Amount used for feedstock without prior capture (4), Amount destroyed without prior capture (5) and Amount of generated emissions (6)'
              ))
            }
            // when all fields are set, sum must be EQUAL
            if (
              !someEmpty(_fields)
              && isDifferentThanSum(this.quantity_generated, _fields)
            ) {
              errors.push($gettext(
                'Total amount generated (2) must be equal to the sum of its components: Amount generated and captured for all uses (3a), Amount used for feedstock without prior capture (4), Amount destroyed without prior capture (5) and Amount of generated emissions (6)'
              ))
            }
          } */

          const returnObj = {
            type: 'nonInput',
            selected: errors
          }

          return returnObj
        }
      }
      if (prefillData) {
        Object.keys(prefillData).forEach((element) => {
          row[element].selected = isNumber(prefillData[element]) ? parseFloat(fromExponential(prefillData[element])) : prefillData[element]
        })
      }
      return row
    default:
      break
    }
  },

  substanceRows({
    $gettext, section, substance, group, country, blend, prefillData, is_captured
  }) {
    const countryFieldName = getCountryField(section)

    let baseInnerFields = {
      checkForDelete: {
        selected: false,
        type: 'checkbox'
      },
      substance: {
        type: 'select',
        selected: substance || null
      },
      blend: {
        type: 'select',
        selected: blend || null,
        expand: false
      },
      group: {
        selected: group,
        type: 'nonInput'
      },
      quantity_total_new: {
        type: 'number',
        selected: null
      },
      quantity_total_recovered: {
        type: 'number',
        selected: null
      },
      quantity_feedstock: {
        type: 'number',
        selected: null
      },
      get quantity_exempted() {
        const fields = ['quantity_essential_uses', 'quantity_critical_uses', 'quantity_high_ambient_temperature', 'quantity_process_agent_uses', 'quantity_laboratory_analytical_uses', 'quantity_other_uses']
        return quantityCalculator(fields, this, section, $gettext)
      },

      get decision_exempted() {
        const fields = ['decision_essential_uses', 'decision_critical_uses', 'decision_high_ambient_temperature', 'decision_process_agent_uses', 'decision_laboratory_analytical_uses', 'decision_other_uses']
        return decisionGenerator(fields, this, section, $gettext)
      },
      quantity_essential_uses: {
        type: 'number',
        selected: null
      },
      decision_essential_uses: {
        type: 'text',
        selected: ''
      },
      quantity_critical_uses: {
        type: 'number',
        selected: null
      },
      decision_critical_uses: {
        type: 'text',
        selected: ''
      },
      quantity_high_ambient_temperature: {
        type: 'number',
        selected: null
      },
      decision_high_ambient_temperature: {
        type: 'text',
        selected: ''
      },
      quantity_process_agent_uses: {
        type: 'number',
        selected: null
      },
      decision_process_agent_uses: {
        type: 'text',
        selected: ''
      },
      quantity_laboratory_analytical_uses: {
        type: 'number',
        selected: null
      },
      decision_laboratory_analytical_uses: {
        type: 'text',
        selected: ''
      },
      quantity_quarantine_pre_shipment: {
        type: 'number',
        selected: null
      },
      decision_quarantine_pre_shipment: {
        type: 'text',
        selected: ''
      },
      quantity_other_uses: {
        type: 'number',
        selected: null
      },
      decision_other_uses: {
        type: 'text',
        selected: ''
      },
      quantity_polyols: {
        type: 'number',
        selected: null
      },
      decision_polyols: {
        type: 'text',
        selected: ''
      },
      remarks_party: {
        type: 'textarea',
        selected: ''
      },
      remarks_os: {
        type: 'textarea',
        selected: ''
      },
      derived_substance_data: {
        type: 'select',
        selected: []
      },
      get validation() {
        const errors = []
        if (allEmpty([
          this.quantity_feedstock,
          this.quantity_exempted,
          this.quantity_quarantine_pre_shipment,
          this.quantity_total_new,
          this.quantity_total_recovered,
          this.quantity_polyols
        ])) {
          errors.push($gettext(
            'The row cannot be empty. Please fill in any column'
          ))
        }

        if (this.skipValidation === 0) {
          if (allEmpty([
            this.quantity_total_new,
            this.quantity_total_recovered,
            this.quantity_polyols
          ])) {
            errors.push($gettext(
              'Please fill-in column Total quantity for all uses (3 or 4)'
            ))
          }
          if (isLessThanSum(
            this.quantity_total_new,
            [
              this.quantity_feedstock,
              this.quantity_exempted,
              this.quantity_quarantine_pre_shipment
            ]
          )) {
            errors.push($gettext(
              'Total quantity for all uses (3) must be greater than or equal to the sum of its individual components (5+6)'
            ))
          }
        }

        if (this.skipValidation === 2) {
          errors.push($gettext(
            'Total quantity for all uses (3) must be greater than or equal to the sum of its individual components (5+6) for all parties'
          ))
        }

        const returnObj = {
          type: 'nonInput',
          selected: errors
        }

        return returnObj
      },
      // This might be confuzing. We're using a trilean here
      // 0 is base state, 1 is valid for multirow validation, 2 is invalid for multirow validation
      skipValidation: 0
    }

    baseInnerFields[countryFieldName] = {
      type: 'multiselect',
      selected: country || null
    }

    switch (section) {
    case 'has_produced':
      baseInnerFields = {
        checkForDelete: {
          selected: false,
          type: 'checkbox'
        },
        remarks_party: {
          type: 'textarea',
          selected: ''
        },
        remarks_os: {
          type: 'textarea',
          selected: ''
        },
        group: {
          selected: group,
          type: 'nonInput'
        },
        is_captured: {
          type: 'nonInput',
          selected: is_captured || false
        },
        get quantity_exempted() {
          const fields = ['quantity_critical_uses', 'quantity_essential_uses', 'quantity_high_ambient_temperature', 'quantity_laboratory_analytical_uses', 'quantity_process_agent_uses', 'quantity_other_uses']
          return quantityCalculator(fields, this, section, $gettext)
        },
        get decision_exempted() {
          const fields = ['decision_critical_uses', 'decision_essential_uses', 'decision_high_ambient_temperature', 'decision_laboratory_analytical_uses', 'decision_process_agent_uses', 'decision_other_uses']
          return decisionGenerator(fields, this, section, $gettext)
        },
        quantity_critical_uses: {
          type: 'number',
          selected: null
        },
        decision_critical_uses: {
          type: 'text',
          selected: ''
        },
        quantity_essential_uses: {
          type: 'number',
          selected: null
        },
        decision_essential_uses: {
          type: 'text',
          selected: ''
        },
        quantity_high_ambient_temperature: {
          type: 'number',
          selected: null
        },
        decision_high_ambient_temperature: {
          type: 'text',
          selected: ''
        },
        quantity_laboratory_analytical_uses: {
          type: 'number',
          selected: null
        },
        decision_laboratory_analytical_uses: {
          type: 'text',
          selected: ''
        },
        quantity_process_agent_uses: {
          type: 'number',
          selected: null
        },
        decision_process_agent_uses: {
          type: 'text',
          selected: ''
        },
        quantity_quarantine_pre_shipment: {
          type: 'number',
          selected: null
        },
        decision_quarantine_pre_shipment: {
          type: 'text',
          selected: ''
        },
        quantity_total_produced: {
          type: 'number',
          selected: null
        },
        quantity_other_uses: {
          type: 'number',
          selected: null
        },
        decision_other_uses: {
          type: 'text',
          selected: ''
        },
        quantity_feedstock: {
          type: 'number',
          selected: null,
          colspan: 2
        },
        quantity_for_destruction: {
          type: 'number',
          selected: null
        },
        quantity_article_5: {
          type: 'number',
          selected: null
        },
        substance: {
          type: 'select',
          selected: substance || null
        },
        get validation() {
          const errors = []
          if (this.quantity_total_produced.selected === null) {
            errors.push($gettext(
              'Please fill-in column Total production for all uses (3)'
            ))
          }

          if (this.group.selected && ['A', 'B', 'C', 'a', 'b', 'c'].includes(this.group.selected.split('')[0])) {
            if (isLessThanSum(
              this.quantity_total_produced,
              [
                this.quantity_feedstock,
                this.quantity_exempted,
                this.quantity_article_5
              ]
            )) {
              errors.push($gettext(
                'Total production for all uses (3) must be greater than or equal to the sum of Feedstock (4), Exempted amounts (5) and Production for BDN of Article 5 countries (7)'
              ))
            }
          }

          if (this.group.selected && ['E', 'e'].includes(this.group.selected.split('')[0])) {
            if (isLessThanSum(
              this.quantity_total_produced,
              [
                this.quantity_feedstock,
                this.quantity_exempted,
                this.quantity_quarantine_pre_shipment
              ]
            )) {
              errors.push($gettext(
                'Total production for all uses (3) must be greater than or equal to the sum of Feedstock (4), Exempted amounts (5) and QPS'
              ))
            }
          }
          if (this.group.selected && ['F', 'f'].includes(this.group.selected) && !this.is_captured.selected) {
            if (isLessThanSum(
              this.quantity_total_produced,
              [
                this.quantity_feedstock,
                this.quantity_exempted
              ]
            )) {
              errors.push($gettext(
                'Total production for all uses (3) must be greater than or equal to the sum of Feedstock (4) and Exempted amounts (5)'
              ))
            }
          }

          if (this.group.selected && ['F', 'f'].includes(this.group.selected) && this.is_captured.selected) {
            if (isLessThanSum(
              this.quantity_total_produced,
              [
                this.quantity_feedstock,
                this.quantity_for_destruction,
                this.quantity_exempted
              ]
            )) {
              errors.push($gettext(
                'Captured for all uses (3) must be greater than or equal to the sum of Feedstock (4a), Amounts destroyed (4b) and Exempted amounts (5)'
              ))
            }
          }
          const returnObj = {
            type: 'nonInput',
            selected: errors
          }

          return returnObj
        }
      }
      break
    case 'has_destroyed':
      baseInnerFields = {
        checkForDelete: {
          selected: false,
          type: 'checkbox'
        },
        substance: {
          type: 'select',
          selected: substance || null
        },
        blend: {
          type: 'select',
          selected: blend || null,
          expand: false
        },
        quantity_destroyed: {
          type: 'number',
          selected: null
        },
        group: {
          selected: group,
          type: 'nonInput'
        },
        remarks_party: {
          type: 'textarea',
          selected: ''
        },
        remarks_os: {
          type: 'textarea',
          selected: ''
        },
        get validation() {
          const errors = []
          if (this.quantity_destroyed.selected === null) {
            errors.push($gettext(
              'Please fill-in column Quantity destroyed (2)'
            ))
          }

          const returnObj = {
            type: 'nonInput',
            selected: errors
          }

          return returnObj
        }
      }
      break
    case 'has_nonparty':
      baseInnerFields = {
        checkForDelete: {
          selected: false,
          type: 'checkbox'
        },
        remarks_party: {
          type: 'textarea',
          selected: ''
        },
        remarks_os: {
          type: 'textarea',
          selected: ''
        },
        quantity_import_new: {
          type: 'text',
          selected: null
        },
        quantity_import_recovered: {
          type: 'text',
          selected: null
        },
        quantity_export_new: {
          type: 'text',
          selected: null
        },
        quantity_export_recovered: {
          type: 'text',
          selected: null
        },
        substance: {
          type: 'select',
          selected: substance || null
        },
        blend: {
          type: 'select',
          selected: blend || null,
          expand: false
        },
        group: {
          selected: group,
          type: 'nonInput'
        },
        trade_party: {
          type: 'multiselect',
          selected: country || null
        },
        get validation() {
          const errors = []
          if (allEmpty([
            this.quantity_import_new,
            this.quantity_import_recovered,
            this.quantity_export_new,
            this.quantity_export_recovered
          ])) {
            errors.push($gettext(
              'Please fill-in one of columns New imports (4), Recovered and reclaimed imports (5), New exports (6) or Recovered and reclaimed exports (7)'
            ))
          }

          const returnObj = {
            type: 'nonInput',
            selected: errors
          }

          return returnObj
        }
      }
      break
    default:
      break
    }
    if (prefillData) {
      Object.keys(prefillData).forEach((field) => {
        baseInnerFields[field]
          ?	baseInnerFields[field].selected = isNumber(prefillData[field])
            ? parseFloat(fromExponential(prefillData[field])) : prefillData[field]
          : null
      })
    }
    return baseInnerFields
  }

}
